import moment from "moment";

// https://momentjs.com/docs/#/parsing/string-format/

const FORMAT_LOCAL_DATE = 'DD.MM.YYYY';

const addYears = (date: moment.Moment, years: number) => {
    return moment(date).add(years, 'y');
}

const formatLocalDate = (date: moment.Moment) => {
    return date.format(FORMAT_LOCAL_DATE);
}

const parseLocalDate = (date: string) => {
    return moment(date, FORMAT_LOCAL_DATE, true)
}

const startOfDayNow = () => {
    return moment().startOf('day');
}
const DateMomentUtil = {
    addYears,
    formatLocalDate,
    parseLocalDate,
    startOfDayNow
}

export default DateMomentUtil;